import { render, staticRenderFns } from "./McustomerView.vue?vue&type=template&id=99750796&scoped=true"
import script from "./McustomerView.vue?vue&type=script&lang=js"
export * from "./McustomerView.vue?vue&type=script&lang=js"
import style0 from "./McustomerView.vue?vue&type=style&index=0&id=99750796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99750796",
  null
  
)

export default component.exports